import { createFormAjaxInstances, FormAjaxUI } from './formAjaxUI';
import Axios from 'axios';
import Utils from '../../../utils/utils';
import { Notification } from '../../../notification/notfication';
import i18next from 'i18next';

class FormAjax {
    constructor(private ui: FormAjaxUI) {
        this.ui.onSubmit(this.submit.bind(this));
    }
    
    public submit() {
        this.ui.disableSubmitButton();
        Axios.post(this.ui.getFormAction(), Utils.getFromData(this.ui.getFormName()), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then((response) => {
            this.ui.enableSubmitButton();
            new Notification('success',
                i18next.t('gameserver:configuration.save.notifications.success.title'),
                i18next.t('gameserver:configuration.save.notifications.success.text')
            );
        }).catch(() => {
            this.ui.enableSubmitButton();
            new Notification('danger',
                i18next.t('gameserver:configuration.save.notifications.error.title'),
                i18next.t('gameserver:configuration.save.notifications.error.text')
            );
        });
    }
}

export function initFormAjax() {
    const instances = createFormAjaxInstances();
    return instances.map((ui: FormAjaxUI) => {
        return new FormAjax(ui);
    });
}
